import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  // Preencher automaticamente em desenvolvimento
  const isDevelopment = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;

  const [email, setEmail] = useState(isDevelopment ? 'admin@cmcb.ce.gov.br' : '');
  const [password, setPassword] = useState(isDevelopment ? 'admin123' : '');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  // Quando o backend responde com requiresRoleSelection, guardamos as opções
  // aqui e renderizamos um modal pro usuário escolher.
  const [roleChoices, setRoleChoices] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const ROLE_LABELS = {
    // Neutro: um instrutor civil também entra com role='user'.
    user: 'Instrutor',
    fiscal: 'Fiscal',
    visualizador: 'Visualizador',
    admin: 'Administrador',
  };

  const navigateByRole = (role) => {
    if (role === 'admin') navigate('/admin/dashboard');
    else if (role === 'fiscal') navigate('/fiscal/dashboard');
    else if (role === 'visualizador') navigate('/visualizador/dashboard');
    else navigate('/user/dashboard');
  };

  const attemptLogin = async (chosenRole) => {
    setError('');
    setShowToast(false);
    setLoading(true);
    try {
      const result = await login(email, password, chosenRole);

      if (result?.requiresRoleSelection) {
        setRoleChoices(result.availableRoles || []);
        return;
      }

      navigateByRole(result.user.role);
    } catch (err) {
      setError('Credenciais incorretas');
      setShowToast(true);
      console.error('Erro no login:', err);
      setTimeout(() => setShowToast(false), 4000);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await attemptLogin();
  };

  const handlePickRole = async (role) => {
    setRoleChoices(null);
    await attemptLogin(role);
  };

  return (
    <div className="login-page">
      {/* Modal de escolha de função (quando o usuário tem >1) */}
      {roleChoices && (
        <div className="role-picker-overlay" role="dialog" aria-modal="true">
          <div className="role-picker-modal">
            <h3>Você tem mais de uma função</h3>
            <p>Como deseja entrar agora?</p>
            <div className="role-picker-options">
              {roleChoices.map((r) => (
                <button
                  key={r}
                  type="button"
                  className="role-picker-btn"
                  onClick={() => handlePickRole(r)}
                  disabled={loading}
                >
                  {ROLE_LABELS[r] || r}
                </button>
              ))}
            </div>
            <button
              type="button"
              className="role-picker-cancel"
              onClick={() => { setRoleChoices(null); setPassword(''); }}
              disabled={loading}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Toast de erro */}
      {showToast && (
        <div className="toast toast-error">
          <div className="toast-icon">⚠️</div>
          <div className="toast-content">
            <strong>Erro de autenticação</strong>
            <p>Credenciais incorretas. Verifique seu e-mail e senha.</p>
          </div>
          <button className="toast-close" onClick={() => setShowToast(false)}>✕</button>
        </div>
      )}

      {/* Lado esquerdo - Verde */}
      <div className="login-left">
        <div className="login-left-content">
          {/* Emblema Oficial CBMCE */}
          <div className="brasao-cmcb">
            <img
              src="/emblema-cbmce.png"
              alt="Corpo de Bombeiros Militar do Ceará"
              className="emblema-oficial"
            />
          </div>

          <h1 className="login-title">Acompanhamento de Horas</h1>
          <p className="login-subtitle">Colégio Militar do Corpo de Bombeiros</p>
          <p className="login-state">Governo do Estado do Ceará</p>
        </div>
      </div>

      {/* Lado direito - Branco */}
      <div className="login-right">
        <div className="login-box-modern">
          <div className="login-header-modern">
            <h2>Bem-vindo</h2>
            <p>Entre com suas credenciais</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form-modern">
            <div className="form-group-modern">
              <label htmlFor="email">Matrícula ou E-mail</label>
              <div className="input-wrapper">
                <input
                  id="email"
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="Informe sua matrícula ou e-mail"
                  disabled={loading}
                  className={error ? 'input-error' : ''}
                />
                <span className="input-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </span>
              </div>
            </div>

            <div className="form-group-modern">
              <label htmlFor="password">Senha</label>
              <div className="input-wrapper">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Digite sua senha"
                  disabled={loading}
                  className={error ? 'input-error' : ''}
                />
                <button
                  type="button"
                  className="input-icon-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex="-1"
                >
                  {showPassword ? (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button type="submit" className="btn-login-modern" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Entrando...
                </>
              ) : (
                <>
                  Entrar
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                    <polyline points="10 17 15 12 10 7"/>
                    <line x1="15" y1="12" x2="3" y2="12"/>
                  </svg>
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
